import React from 'react';
import { Route, Redirect } from 'react-router-dom';

// PrivateRoute component to protect routes
const PrivateRoute = ({ component: Component, ...rest }) => {
  const isAuthenticated = localStorage.getItem('authToken'); // Check if user is authenticated

  return (
    <Route
      {...rest}
      render={(props) =>
        isAuthenticated ? (
          <Component {...props} />
        ) : (
          <Redirect to="/" /> // Redirect to sign-in if not authenticated
        )
      }
    />
  );
};

export default PrivateRoute;
